import { useMediaQuery, useTheme } from '@mui/material';
import { useEffect, useState } from 'react';
import DoNotDisturbAltIcon from '@mui/icons-material/DoNotDisturbAlt';

export const Locationwhite = () => {
  const onlySmallScreen = useMediaQuery((theme) =>
    theme.breakpoints.down('md')
  );
  return (
    <svg
      width={onlySmallScreen ? '40' : '48'}
      height={onlySmallScreen ? '40' : '48'}
      viewBox="0 0 35 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.3053 0.0450229C7.98926 0.0133737 0.379895 7.42523 0.0757602 16.7028L0.0664062 17.2787C0.221252 21.8261 1.76845 26.1609 4.49353 29.7323L5.13353 30.5675C7.73465 33.8749 10.8258 36.7779 14.2966 39.1705L15.1323 39.7331L15.2542 39.8288C16.4438 40.6836 18.05 40.6836 19.2396 39.8288L19.3411 39.7454C22.0952 37.9594 24.6348 35.8608 26.9096 33.4912C31.5345 28.5955 34.322 23.11 34.4273 17.5388L34.4275 17.332C34.4591 7.99234 27.07 0.359571 17.821 0.0544024L17.3053 0.0450229ZM17.297 3.11303C24.9343 3.13914 31.1352 9.24138 31.3654 16.8407L31.372 17.5107C31.2835 22.1815 28.8379 26.9941 24.7007 31.3736C22.5912 33.5709 20.2259 35.5241 17.6606 37.1853L17.4896 37.3138C17.3515 37.4337 17.1465 37.4337 17.0084 37.3138L16.8422 37.1884C13.0206 34.6933 9.66656 31.5431 6.93341 27.882C4.73189 24.9966 3.42732 21.5467 3.16474 17.9479L3.12615 17.2262C3.15209 9.57043 9.23553 3.35056 16.8115 3.1196L17.297 3.11303ZM17.2465 10.9632C13.6317 10.9632 10.7014 13.9026 10.7014 17.5286C10.7014 21.1545 13.6317 24.0939 17.2465 24.0939C20.8613 24.0939 23.7917 21.1545 23.7917 17.5286C23.7917 13.9026 20.8613 10.9632 17.2465 10.9632ZM17.2486 14.0313C19.1747 14.0313 20.7361 15.5975 20.7361 17.5296C20.7361 19.4616 19.1747 21.0278 17.2486 21.0278C15.3225 21.0278 13.7611 19.4616 13.7611 17.5296C13.7611 15.5975 15.3225 14.0313 17.2486 14.0313Z"
        fill="#112347"
      />
    </svg>
  );
};

export const SelectIcon = () => {
  const onlySmallScreen = useMediaQuery((theme) =>
    theme.breakpoints.down('md')
  );
  return (
    <svg
      width={onlySmallScreen ? '15' : '35'}
      height={onlySmallScreen ? '15' : '35'}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.7">
        <mask id="path-1-inside-1_0_1" fill="white">
          <path d="M32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16ZM2.38538 16C2.38538 23.5191 8.48085 29.6146 16 29.6146C23.5191 29.6146 29.6146 23.5191 29.6146 16C29.6146 8.48085 23.5191 2.38538 16 2.38538C8.48085 2.38538 2.38538 8.48085 2.38538 16Z" />
        </mask>
        <path
          d="M32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16ZM2.38538 16C2.38538 23.5191 8.48085 29.6146 16 29.6146C23.5191 29.6146 29.6146 23.5191 29.6146 16C29.6146 8.48085 23.5191 2.38538 16 2.38538C8.48085 2.38538 2.38538 8.48085 2.38538 16Z"
          fill="white"
          stroke="#6C2AD2"
          stroke-width="50"
          mask="url(#path-1-inside-1_0_1)"
        />
      </g>
      <g clip-path="url(#clip0_0_1)">
        <path
          d="M11.125 15.5L14.25 18.625L20.5 12.375"
          stroke="#6C2AD2"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_0_1">
          <rect
            width="15"
            height="15"
            fill="white"
            transform="translate(8 8)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const OverAllIcon = ({ value }) => {
  const [innerHeight, setInnerHeight] = useState(window.innerHeight);
  useEffect(() => {
    const handleResize = () => {
      setInnerHeight(window.innerHeight);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down(500));
  const onlySmallScreen = useMediaQuery((theme) =>
    theme.breakpoints.down('md')
  );
  return (
    <svg
      width={matchessm ? '40' : onlySmallScreen ? '78' : '118'}
      height={matchessm ? '40' : onlySmallScreen ? '78' : '118'}
      viewBox="0 0 118 118"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.75 24.584H68.8333"
        stroke={value ? '#6C2AD2' : '#0D0D0D'}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M59 34.4167L68.8333 24.5833L59 14.75"
        stroke={value ? '#6C2AD2' : '#0D0D0D'}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M24.5833 14.75L14.75 24.5833L24.5833 34.4167"
        stroke={value ? '#6C2AD2' : '#0D0D0D'}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M93.418 49.166V103.249"
        stroke={value ? '#6C2AD2' : '#0D0D0D'}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M83.582 93.416L93.4154 103.249L103.249 93.416"
        stroke={value ? '#6C2AD2' : '#0D0D0D'}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M103.249 58.9993L93.4154 49.166L83.582 58.9993"
        stroke={value ? '#6C2AD2' : '#0D0D0D'}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M59 49.166H24.5833C19.1525 49.166 14.75 53.5685 14.75 58.9993V93.416C14.75 98.8468 19.1525 103.249 24.5833 103.249H59C64.4308 103.249 68.8333 98.8468 68.8333 93.416V58.9993C68.8333 53.5685 64.4308 49.166 59 49.166Z"
        stroke={value ? '#6C2AD2' : '#0D0D0D'}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const Bedrooms = ({ value }) => {
  const [innerHeight, setInnerHeight] = useState(window.innerHeight);
  useEffect(() => {
    const handleResize = () => {
      setInnerHeight(window.innerHeight);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down(500));

  const onlySmallScreen = useMediaQuery((theme) =>
    theme.breakpoints.down('md')
  );
  return (
    <svg
      width={matchessm ? '40' : onlySmallScreen ? '78' : '118'}
      height={matchessm ? '40' : onlySmallScreen ? '78' : '118'}
      viewBox="0 0 118 118"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_25549_222777)">
        <path
          d="M14.75 34.416V88.4993M14.75 68.8327H103.25M103.25 88.4993V49.166C103.25 46.5581 102.214 44.0569 100.37 42.2128C98.5258 40.3687 96.0246 39.3327 93.4167 39.3327H54.0833V68.8327"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M34.4167 54.0833C37.1321 54.0833 39.3333 51.8821 39.3333 49.1667C39.3333 46.4513 37.1321 44.25 34.4167 44.25C31.7013 44.25 29.5 46.4513 29.5 49.1667C29.5 51.8821 31.7013 54.0833 34.4167 54.0833Z"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_25549_222777">
          <rect width="118" height="118" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Location = ({ value }) => {
  const [innerHeight, setInnerHeight] = useState(window.innerHeight);
  useEffect(() => {
    const handleResize = () => {
      setInnerHeight(window.innerHeight);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down(500));

  const onlySmallScreen = useMediaQuery((theme) =>
    theme.breakpoints.down('md')
  );
  return (
    <svg
      width={matchessm ? '40' : onlySmallScreen ? '50' : '75'}
      height={matchessm ? '40' : onlySmallScreen ? '50' : '75'}
      viewBox="0 0 75 75"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_25549_222766)">
        <path
          d="M65.6238 9.375L45.3113 65.625C45.1742 65.9242 44.9541 66.1777 44.6771 66.3555C44.4001 66.5332 44.0779 66.6277 43.7488 66.6277C43.4197 66.6277 43.0975 66.5332 42.8205 66.3555C42.5435 66.1777 42.3234 65.9242 42.1863 65.625L31.2488 43.75L9.37382 32.8125C9.07462 32.6754 8.82109 32.4553 8.64333 32.1783C8.46558 31.9013 8.37109 31.5791 8.37109 31.25C8.37109 30.9209 8.46558 30.5987 8.64333 30.3217C8.82109 30.0447 9.07462 29.8246 9.37382 29.6875L65.6238 9.375Z"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_25549_222766">
          <rect width="75" height="75" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Garden = ({ value }) => {
  const [innerHeight, setInnerHeight] = useState(window.innerHeight);
  useEffect(() => {
    const handleResize = () => {
      setInnerHeight(window.innerHeight);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down(500));

  const onlySmallScreen = useMediaQuery((theme) =>
    theme.breakpoints.down('md')
  );
  return (
    <svg
      width={onlySmallScreen ? '40' : '190'}
      height={onlySmallScreen ? '40' : '190'}
      viewBox="0 0 53 53"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_25572_225400)">
        <path
          d="M26.4987 28.7077L22.082 24.291"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M26.5 26.5007L30.9167 22.084"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M26.5 46.3744V17.666"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          stroke-width="1"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M21.696 35.3214C20.7298 35.2648 19.7877 34.9972 18.936 34.5374C18.0843 34.0776 17.3437 33.4368 16.7663 32.6601C16.1889 31.8833 15.7887 30.9894 15.5939 30.0414C15.399 29.0934 15.4143 28.1141 15.6385 27.1726C14.8371 26.5064 14.2042 25.6605 13.7915 24.7035C13.3787 23.7466 13.1976 22.7057 13.2631 21.6656C13.3285 20.6255 13.6385 19.6156 14.168 18.7179C14.6974 17.8202 15.4313 17.0602 16.3099 16.4997C15.54 15.132 15.2807 13.5354 15.5782 11.9943C15.8756 10.4532 16.7106 9.06784 17.9342 8.08494C19.1579 7.10205 20.6907 6.58551 22.2597 6.62736C23.8287 6.6692 25.3318 7.26672 26.5013 8.31344C27.6711 7.26837 29.1738 6.67227 30.7418 6.63124C32.3099 6.59021 33.8417 7.1069 35.0645 8.08936C36.2874 9.07181 37.1219 10.4563 37.4197 11.9964C37.7174 13.5365 37.4591 15.1323 36.6906 16.4997C37.5697 17.0597 38.3041 17.8195 38.8341 18.717C39.364 19.6146 39.6744 20.6247 39.7401 21.665C39.8057 22.7052 39.6247 23.7463 39.2119 24.7034C38.799 25.6605 38.1659 26.5065 37.3641 27.1726C37.5959 28.146 37.6042 29.1593 37.3884 30.1364C37.1726 31.1135 36.7382 32.029 36.1179 32.8142C35.4976 33.5994 34.7075 34.2339 33.8069 34.67C32.9063 35.1061 31.9186 35.3326 30.918 35.3324H22.0847L21.696 35.3214Z"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          stroke-width="1"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_25572_225400">
          <rect width="53" height="53" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Floorplan = ({ value }) => {
  const [innerHeight, setInnerHeight] = useState(window.innerHeight);
  useEffect(() => {
    const handleResize = () => {
      setInnerHeight(window.innerHeight);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down(500));

  const onlySmallScreen = useMediaQuery((theme) =>
    theme.breakpoints.down('md')
  );
  return (
    <svg
      width={matchessm ? '40' : '97'}
      height={matchessm ? '40' : '97'}
      viewBox="0 0 97 97"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_25549_222769)">
        <path
          d="M12.125 84.8749H28.2917L80.8333 32.3333C82.9772 30.1894 84.1816 27.2818 84.1816 24.2499C84.1816 21.2181 82.9772 18.3104 80.8333 16.1666C78.6895 14.0228 75.7818 12.8184 72.75 12.8184C69.7182 12.8184 66.8105 14.0228 64.6667 16.1666L12.125 68.7083V84.8749Z"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M58.6055 22.2285L74.7721 38.3952"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M48.5 32.3333L28.2917 12.125L12.125 28.2917L32.3333 48.5"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M28.293 32.334L22.2305 38.3965"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M64.6667 48.5L84.875 68.7083L68.7083 84.875L48.5 64.6667"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M64.668 68.709L58.6055 74.7715"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_25549_222769">
          <rect width="97" height="97" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const NaturalLightIcon = ({ value }) => {
  const [innerHeight, setInnerHeight] = useState(window.innerHeight);
  useEffect(() => {
    const handleResize = () => {
      setInnerHeight(window.innerHeight);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down(500));

  const onlySmallScreen = useMediaQuery((theme) =>
    theme.breakpoints.down('md')
  );
  return (
    <svg
      width={matchessm ? '40' : '118'}
      height={matchessm ? '40' : '118'}
      viewBox="0 0 118 118"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_25549_222762)">
        <path
          d="M58.9987 78.6673C69.8603 78.6673 78.6654 69.8623 78.6654 59.0007C78.6654 48.1391 69.8603 39.334 58.9987 39.334C48.1371 39.334 39.332 48.1391 39.332 59.0007C39.332 69.8623 48.1371 78.6673 58.9987 78.6673Z"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M14.75 59H19.6667M59 14.75V19.6667M98.3333 59H103.25M59 98.3333V103.25M27.5333 27.5333L30.975 30.975M90.4667 27.5333L87.025 30.975M87.025 87.025L90.4667 90.4667M30.975 87.025L27.5333 90.4667"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_25549_222762">
          <rect width="118" height="118" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const LoadingIcon = ({ onlySmallScreen }) => {
  return (
    <svg
      width={onlySmallScreen ? '15' : '23'}
      height={onlySmallScreen ? '15' : '23'}
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="11.5" cy="11.5" r="11.5" fill="#9A9A9F" />
    </svg>
  );
};

export const SuccessBtn = () => {
  return (
    <svg
      width="100"
      height="100"
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M50.0007 10.6673C39.5688 10.6673 29.5642 14.8114 22.1878 22.1878C14.8114 29.5642 10.6673 39.5688 10.6673 50.0007C10.6673 60.4325 14.8114 70.4371 22.1878 77.8135C29.5642 85.1899 39.5688 89.334 50.0007 89.334C60.4325 89.334 70.4371 85.1899 77.8135 77.8135C85.1899 70.4371 89.334 60.4325 89.334 50.0007C89.334 39.5688 85.1899 29.5642 77.8135 22.1878C70.4371 14.8114 60.4325 10.6673 50.0007 10.6673ZM0.833984 50.0007C0.833984 22.8459 22.8459 0.833984 50.0007 0.833984C77.1554 0.833984 99.1673 22.8459 99.1673 50.0007C99.1673 77.1554 77.1554 99.1673 50.0007 99.1673C22.8459 99.1673 0.833984 77.1554 0.833984 50.0007ZM72.932 34.0362C73.9054 34.9025 74.4952 36.1197 74.5717 37.4205C74.6482 38.7213 74.2052 39.9993 73.3401 40.9736L47.1195 70.4736C46.6582 70.9927 46.0922 71.4082 45.4587 71.6927C44.8253 71.9773 44.1387 72.1244 43.4443 72.1244C42.7498 72.1244 42.0633 71.9773 41.4298 71.6927C40.7964 71.4082 40.2304 70.9927 39.7691 70.4736L26.6612 55.7236C25.8456 54.7426 25.4434 53.4829 25.5393 52.2107C25.6353 50.9385 26.2221 49.7534 27.1756 48.9058C28.1292 48.0582 29.3749 47.6145 30.6495 47.6683C31.9242 47.7221 33.128 48.2693 34.0067 49.1943L43.4467 59.8094L65.9946 34.4394C66.8615 33.4667 68.0791 32.8778 69.3798 32.8022C70.6806 32.7266 71.9582 33.1705 72.932 34.0362Z"
        fill="#0D0D0D"
      />
    </svg>
  );
};

export const CancelBtn = () => {
  return (
    <svg
      width="100"
      height="100"
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M50.0007 10.6673C39.5688 10.6673 29.5642 14.8114 22.1878 22.1878C14.8114 29.5642 10.6673 39.5688 10.6673 50.0007C10.6673 60.4325 14.8114 70.4371 22.1878 77.8135C29.5642 85.19 39.5688 89.334 50.0007 89.334C60.4325 89.334 70.4371 85.19 77.8135 77.8135C85.19 70.4371 89.334 60.4325 89.334 50.0007C89.334 39.5688 85.19 29.5642 77.8135 22.1878C70.4371 14.8114 60.4325 10.6673 50.0007 10.6673ZM0.833984 50.0007C0.833984 22.8459 22.8459 0.833984 50.0007 0.833984C77.1554 0.833984 99.1673 22.8459 99.1673 50.0007C99.1673 77.1554 77.1554 99.1673 50.0007 99.1673C22.8459 99.1673 0.833984 77.1554 0.833984 50.0007ZM29.3162 29.3162C30.2382 28.3945 31.4886 27.8767 32.7923 27.8767C34.096 27.8767 35.3464 28.3945 36.2684 29.3162L50.0007 43.0485L63.7329 29.3162C64.1865 28.8466 64.729 28.4721 65.3288 28.2144C65.9287 27.9567 66.5739 27.8211 67.2267 27.8154C67.8795 27.8097 68.5269 27.9341 69.1312 28.1814C69.7354 28.4286 70.2844 28.7937 70.746 29.2553C71.2076 29.7169 71.5727 30.2659 71.8199 30.8701C72.0672 31.4744 72.1916 32.1218 72.1859 32.7746C72.1802 33.4275 72.0446 34.0726 71.7869 34.6725C71.5292 35.2723 71.1547 35.8149 70.6851 36.2684L56.9528 50.0007L70.6851 63.7329C71.5807 64.6602 72.0763 65.9022 72.0651 67.1913C72.0539 68.4804 71.5368 69.7136 70.6252 70.6252C69.7136 71.5368 68.4804 72.0539 67.1913 72.0651C65.9022 72.0763 64.6602 71.5807 63.7329 70.6851L50.0007 56.9528L36.2684 70.6851C35.3411 71.5807 34.0992 72.0763 32.81 72.0651C31.5209 72.0539 30.2877 71.5368 29.3761 70.6252C28.4645 69.7136 27.9475 68.4804 27.9363 67.1913C27.9251 65.9022 28.4206 64.6602 29.3162 63.7329L43.0485 50.0007L29.3162 36.2684C28.3945 35.3464 27.8767 34.096 27.8767 32.7923C27.8767 31.4886 28.3945 30.2382 29.3162 29.3162Z"
        fill="#6C2AD2"
      />
    </svg>
  );
};

export const SuccessBtnMobile = () => {
  return (
    <svg
      width="59"
      height="59"
      viewBox="0 0 118 118"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M59.0007 19.6673C48.5688 19.6673 38.5642 23.8114 31.1878 31.1878C23.8114 38.5642 19.6673 48.5688 19.6673 59.0007C19.6673 69.4325 23.8114 79.4371 31.1878 86.8135C38.5642 94.1899 48.5688 98.334 59.0007 98.334C69.4325 98.334 79.4371 94.1899 86.8135 86.8135C94.1899 79.4371 98.334 69.4325 98.334 59.0007C98.334 48.5688 94.1899 38.5642 86.8135 31.1878C79.4371 23.8114 69.4325 19.6673 59.0007 19.6673ZM9.83398 59.0007C9.83398 31.8459 31.8459 9.83398 59.0007 9.83398C86.1554 9.83398 108.167 31.8459 108.167 59.0007C108.167 86.1554 86.1554 108.167 59.0007 108.167C31.8459 108.167 9.83398 86.1554 9.83398 59.0007ZM81.932 43.0362C82.9054 43.9025 83.4952 45.1197 83.5717 46.4205C83.6482 47.7213 83.2052 48.9993 82.3401 49.9736L56.1195 79.4736C55.6582 79.9927 55.0922 80.4082 54.4587 80.6927C53.8253 80.9773 53.1387 81.1244 52.4443 81.1244C51.7498 81.1244 51.0633 80.9773 50.4298 80.6927C49.7964 80.4082 49.2304 79.9927 48.7691 79.4736L35.6612 64.7236C34.8456 63.7426 34.4434 62.4829 34.5393 61.2107C34.6353 59.9385 35.2221 58.7534 36.1756 57.9058C37.1292 57.0582 38.3749 56.6145 39.6495 56.6683C40.9242 56.7221 42.128 57.2693 43.0067 58.1943L52.4467 68.8094L74.9946 43.4394C75.8615 42.4667 77.0791 41.8778 78.3798 41.8022C79.6806 41.7266 80.9582 42.1705 81.932 43.0362Z"
        fill="#0D0D0D"
      />
    </svg>
  );
};

export const CancelBtnMobile = () => {
  return (
    <svg
      width="59"
      height="59"
      viewBox="0 0 118 118"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M59.0007 19.6673C48.5688 19.6673 38.5642 23.8114 31.1878 31.1878C23.8114 38.5642 19.6673 48.5688 19.6673 59.0007C19.6673 69.4325 23.8114 79.4371 31.1878 86.8135C38.5642 94.19 48.5688 98.334 59.0007 98.334C69.4325 98.334 79.4371 94.19 86.8135 86.8135C94.19 79.4371 98.334 69.4325 98.334 59.0007C98.334 48.5688 94.19 38.5642 86.8135 31.1878C79.4371 23.8114 69.4325 19.6673 59.0007 19.6673ZM9.83398 59.0007C9.83398 31.8459 31.8459 9.83398 59.0007 9.83398C86.1554 9.83398 108.167 31.8459 108.167 59.0007C108.167 86.1554 86.1554 108.167 59.0007 108.167C31.8459 108.167 9.83398 86.1554 9.83398 59.0007ZM38.3162 38.3162C39.2382 37.3945 40.4886 36.8767 41.7923 36.8767C43.096 36.8767 44.3464 37.3945 45.2684 38.3162L59.0007 52.0485L72.7329 38.3162C73.1865 37.8466 73.729 37.4721 74.3288 37.2144C74.9287 36.9567 75.5739 36.8211 76.2267 36.8154C76.8795 36.8097 77.5269 36.9341 78.1312 37.1814C78.7354 37.4286 79.2844 37.7937 79.746 38.2553C80.2076 38.7169 80.5727 39.2659 80.8199 39.8701C81.0672 40.4744 81.1916 41.1218 81.1859 41.7746C81.1802 42.4275 81.0446 43.0726 80.7869 43.6725C80.5292 44.2723 80.1547 44.8149 79.6851 45.2684L65.9528 59.0007L79.6851 72.7329C80.5807 73.6602 81.0763 74.9022 81.0651 76.1913C81.0539 77.4804 80.5368 78.7136 79.6252 79.6252C78.7136 80.5368 77.4804 81.0539 76.1913 81.0651C74.9022 81.0763 73.6602 80.5807 72.7329 79.6851L59.0007 65.9528L45.2684 79.6851C44.3411 80.5807 43.0992 81.0763 41.81 81.0651C40.5209 81.0539 39.2877 80.5368 38.3761 79.6252C37.4645 78.7136 36.9475 77.4804 36.9363 76.1913C36.9251 74.9022 37.4206 73.6602 38.3162 72.7329L52.0485 59.0007L38.3162 45.2684C37.3945 44.3464 36.8767 43.096 36.8767 41.7923C36.8767 40.4886 37.3945 39.2382 38.3162 38.3162Z"
        fill="#6C2AD2"
      />
    </svg>
  );
};

export const Bathrooms = ({ value }) => {
  const [innerHeight, setInnerHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setInnerHeight(window.innerHeight);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down(500));
  const onlySmallScreen = useMediaQuery((theme) =>
    theme.breakpoints.down('md')
  );

  return (
    <svg
      width={matchessm ? '40' : '118'}
      height={matchessm ? '40' : '118'}
      viewBox="0 0 118 118"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_25549_222778)">
        <path
          d="M25 88.5V70H93V88.5M39.5 70V39.5C39.5 34.5294 41.4871 29.7791 44.9876 26.2786C48.4882 22.778 53.2384 20.791 58.209 20.791C63.1796 20.791 67.9298 22.778 71.4304 26.2786C74.9309 29.7791 76.918 34.5294 76.918 39.5V70"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle
          cx="58.209"
          cy="39.5"
          r="5.5"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
        />
      </g>
      <defs>
        <clipPath id="clip0_25549_222778">
          <rect width="118" height="118" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Months = ({ value }) => {
  const [innerHeight, setInnerHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setInnerHeight(window.innerHeight);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down(500));
  const onlySmallScreen = useMediaQuery((theme) =>
    theme.breakpoints.down('md')
  );

  return (
    <svg
      width={matchessm ? '40' : '118'}
      height={matchessm ? '40' : '118'}
      viewBox="0 0 118 118"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_25549_222779)">
        <rect
          x="20"
          y="30"
          width="78"
          height="60"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
          rx="5"
        />
        <line
          x1="20"
          y1="45"
          x2="98"
          y2="45"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
        />
        <circle cx="35" cy="60" r="5" fill={value ? '#6C2AD2' : '#0D0D0D'} />
        <circle cx="58" cy="60" r="5" fill={value ? '#6C2AD2' : '#0D0D0D'} />
        <circle cx="81" cy="60" r="5" fill={value ? '#6C2AD2' : '#0D0D0D'} />
      </g>
      <defs>
        <clipPath id="clip0_25549_222779">
          <rect width="118" height="118" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Yesterday = ({ value }) => {
  const [innerHeight, setInnerHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setInnerHeight(window.innerHeight);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down(500));
  const onlySmallScreen = useMediaQuery((theme) =>
    theme.breakpoints.down('md')
  );

  return (
    <svg
      width={matchessm ? '40' : '118'}
      height={matchessm ? '40' : '118'}
      viewBox="0 0 118 118"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_25549_222780)">
        <rect
          x="20"
          y="30"
          width="78"
          height="60"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
          rx="5"
        />
        <line
          x1="20"
          y1="45"
          x2="98"
          y2="45"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
        />
        <path
          d="M50 70 L35 60 L50 50"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_25549_222780">
          <rect width="118" height="118" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const WithinWeeks = ({ value }) => {
  const [innerHeight, setInnerHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setInnerHeight(window.innerHeight);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down(500));
  const onlySmallScreen = useMediaQuery((theme) =>
    theme.breakpoints.down('md')
  );

  return (
    <svg
      width={matchessm ? '40' : '118'}
      height={matchessm ? '40' : '118'}
      viewBox="0 0 118 118"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_25549_222781)">
        <rect
          x="20"
          y="30"
          width="78"
          height="60"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
          rx="5"
        />
        <line
          x1="20"
          y1="45"
          x2="98"
          y2="45"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
        />
        <line
          x1="30"
          y1="60"
          x2="88"
          y2="60"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
        />
        <line
          x1="30"
          y1="75"
          x2="88"
          y2="75"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
        />
      </g>
      <defs>
        <clipPath id="clip0_25549_222781">
          <rect width="118" height="118" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const WithinMonths = ({ value }) => {
  const [innerHeight, setInnerHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setInnerHeight(window.innerHeight);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down(500));
  const onlySmallScreen = useMediaQuery((theme) =>
    theme.breakpoints.down('md')
  );

  return (
    <svg
      width={matchessm ? '40' : '118'}
      height={matchessm ? '40' : '118'}
      viewBox="0 0 118 118"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_25549_222782)">
        <rect
          x="20"
          y="30"
          width="78"
          height="60"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
          rx="5"
        />
        <line
          x1="20"
          y1="45"
          x2="98"
          y2="45"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
        />
        <circle cx="35" cy="60" r="5" fill={value ? '#6C2AD2' : '#0D0D0D'} />
        <circle cx="58" cy="60" r="5" fill={value ? '#6C2AD2' : '#0D0D0D'} />
        <circle cx="81" cy="60" r="5" fill={value ? '#6C2AD2' : '#0D0D0D'} />
        <circle cx="35" cy="75" r="5" fill={value ? '#6C2AD2' : '#0D0D0D'} />
        <circle cx="58" cy="75" r="5" fill={value ? '#6C2AD2' : '#0D0D0D'} />
        <circle cx="81" cy="75" r="5" fill={value ? '#6C2AD2' : '#0D0D0D'} />
      </g>
      <defs>
        <clipPath id="clip0_25549_222782">
          <rect width="118" height="118" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const AlwaysActive = ({ value }) => {
  const [innerHeight, setInnerHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setInnerHeight(window.innerHeight);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down(500));
  const onlySmallScreen = useMediaQuery((theme) =>
    theme.breakpoints.down('md')
  );

  return (
    <svg
      width={matchessm ? '40' : '118'}
      height={matchessm ? '40' : '118'}
      viewBox="0 0 118 118"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_25549_222783)">
        <circle
          cx="59"
          cy="59"
          r="40"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
        />
        <path
          d="M59 35V59L77 68"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_25549_222783">
          <rect width="118" height="118" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Self = ({ value }) => {
  const [innerHeight, setInnerHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setInnerHeight(window.innerHeight);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down(500));
  const onlySmallScreen = useMediaQuery((theme) =>
    theme.breakpoints.down('md')
  );

  return (
    <svg
      width={matchessm ? '40' : '118'}
      height={matchessm ? '40' : '118'}
      viewBox="0 0 118 118"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_25549_222784)">
        <circle
          cx="59"
          cy="40"
          r="15"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
        />
        <path
          d="M30 90C30 75 42 65 59 65C76 65 88 75 88 90"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_25549_222784">
          <rect width="118" height="118" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Relative = ({ value }) => {
  const [innerHeight, setInnerHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setInnerHeight(window.innerHeight);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down(500));
  const onlySmallScreen = useMediaQuery((theme) =>
    theme.breakpoints.down('md')
  );

  return (
    <svg
      width={matchessm ? '40' : '118'}
      height={matchessm ? '40' : '118'}
      viewBox="0 0 118 118"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_25549_222785)">
        <circle
          cx="40"
          cy="40"
          r="15"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
        />
        <circle
          cx="78"
          cy="40"
          r="15"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
        />
        <path
          d="M20 90C20 75 32 65 49 65C66 65 78 75 78 90"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M59 90C59 75 71 65 88 65C105 65 118 75 118 90"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_25549_222785">
          <rect width="118" height="118" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Friend = ({ value }) => {
  const [innerHeight, setInnerHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setInnerHeight(window.innerHeight);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down(500));
  const onlySmallScreen = useMediaQuery((theme) =>
    theme.breakpoints.down('md')
  );

  return (
    <svg
      width={matchessm ? '40' : '118'}
      height={matchessm ? '40' : '118'}
      viewBox="0 0 118 118"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_25549_222786)">
        <circle
          cx="40"
          cy="40"
          r="15"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
        />
        <circle
          cx="78"
          cy="40"
          r="15"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
        />
        <path
          d="M30 90C30 75 42 65 59 65C76 65 88 75 88 90"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_25549_222786">
          <rect width="118" height="118" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Company = ({ value }) => {
  const [innerHeight, setInnerHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setInnerHeight(window.innerHeight);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down(500));
  const onlySmallScreen = useMediaQuery((theme) =>
    theme.breakpoints.down('md')
  );

  return (
    <svg
      width={matchessm ? '40' : '118'}
      height={matchessm ? '40' : '118'}
      viewBox="0 0 118 118"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_25549_222787)">
        <rect
          x="30"
          y="30"
          width="58"
          height="58"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
        />
        <path
          d="M30 88H88M44 88V58M59 88V58M74 88V58"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_25549_222787">
          <rect width="118" height="118" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Trust = ({ value }) => {
  const [innerHeight, setInnerHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setInnerHeight(window.innerHeight);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down(500));
  const onlySmallScreen = useMediaQuery((theme) =>
    theme.breakpoints.down('md')
  );

  return (
    <svg
      width={matchessm ? '40' : '118'}
      height={matchessm ? '40' : '118'}
      viewBox="0 0 118 118"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_25549_222788)">
        <path
          d="M59 20L88 35V59C88 75 76 90 59 98C42 90 30 75 30 59V35L59 20Z"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M47 59L56 68L72 50"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_25549_222788">
          <rect width="118" height="118" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Upgrade = ({ value }) => {
  const [innerHeight, setInnerHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setInnerHeight(window.innerHeight);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down(500));
  const onlySmallScreen = useMediaQuery((theme) =>
    theme.breakpoints.down('md')
  );

  return (
    <svg
      width={matchessm ? '40' : '118'}
      height={matchessm ? '40' : '118'}
      viewBox="0 0 118 118"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_25549_222789)">
        <path
          d="M59 20L88 50H70V80H48V50H30L59 20Z"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M30 90H88"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_25549_222789">
          <rect width="118" height="118" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const FirstHome = ({ value }) => {
  const [innerHeight, setInnerHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setInnerHeight(window.innerHeight);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down(500));
  const onlySmallScreen = useMediaQuery((theme) =>
    theme.breakpoints.down('md')
  );

  return (
    <svg
      width={matchessm ? '40' : '118'}
      height={matchessm ? '40' : '118'}
      viewBox="0 0 118 118"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_25549_222790)">
        <path
          d="M20 50L59 20L98 50V98H78V70H40V98H20V50Z"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </g>
      <defs>
        <clipPath id="clip0_25549_222790">
          <rect width="118" height="118" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Downsize = ({ value }) => {
  const [innerHeight, setInnerHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setInnerHeight(window.innerHeight);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down(500));
  const onlySmallScreen = useMediaQuery((theme) =>
    theme.breakpoints.down('md')
  );

  return (
    <svg
      width={matchessm ? '40' : '118'}
      height={matchessm ? '40' : '118'}
      viewBox="0 0 118 118"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_25549_222792)">
        <path
          d="M88 40L59 20L30 40V90H50V65H68V90H88V40Z"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M59 98V75"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M50 85L59 98L68 85"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </g>
      <defs>
        <clipPath id="clip0_25549_222792">
          <rect width="118" height="118" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ApartmentUnit = ({ value }) => {
  const [innerHeight, setInnerHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setInnerHeight(window.innerHeight);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down(500));
  const onlySmallScreen = useMediaQuery((theme) =>
    theme.breakpoints.down('md')
  );

  return (
    <svg
      width={matchessm ? '40' : '118'}
      height={matchessm ? '40' : '118'}
      viewBox="0 0 118 118"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_25549_222793)">
        <path
          d="M30 98V20H88V98H30Z"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M50 98V78H68V98"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M40 35H50V45H40V35Z"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M68 35H78V45H68V35Z"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M40 55H50V65H40V55Z"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M68 55H78V65H68V55Z"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </g>
      <defs>
        <clipPath id="clip0_25549_222793">
          <rect width="118" height="118" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Townhouse = ({ value }) => {
  const [innerHeight, setInnerHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setInnerHeight(window.innerHeight);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down(500));
  const onlySmallScreen = useMediaQuery((theme) =>
    theme.breakpoints.down('md')
  );

  return (
    <svg
      width={matchessm ? '40' : '118'}
      height={matchessm ? '40' : '118'}
      viewBox="0 0 118 118"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_25549_222794)">
        <path
          d="M25 98V45L59 20L93 45V98H25Z"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M40 98V75H55V98"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M63 98V75H78V98"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M32 55H45V65H32V55Z"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M73 55H86V65H73V55Z"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </g>
      <defs>
        <clipPath id="clip0_25549_222794">
          <rect width="118" height="118" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const House = ({ value }) => {
  const [innerHeight, setInnerHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setInnerHeight(window.innerHeight);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down(500));
  const onlySmallScreen = useMediaQuery((theme) =>
    theme.breakpoints.down('md')
  );

  return (
    <svg
      width={matchessm ? '40' : '118'}
      height={matchessm ? '40' : '118'}
      viewBox="0 0 118 118"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_25549_222795)">
        <path
          d="M20 98V50L59 20L98 50V98H20Z"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M45 98V68H73V98"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M30 55H43V65H30V55Z"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M75 55H88V65H75V55Z"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </g>
      <defs>
        <clipPath id="clip0_25549_222795">
          <rect width="118" height="118" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Villa = ({ value }) => {
  const [innerHeight, setInnerHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setInnerHeight(window.innerHeight);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down(500));
  const onlySmallScreen = useMediaQuery((theme) =>
    theme.breakpoints.down('md')
  );

  return (
    <svg
      width={matchessm ? '40' : '118'}
      height={matchessm ? '40' : '118'}
      viewBox="0 0 118 118"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_25549_222796)">
        <path
          d="M15 98V40L59 15L103 40V98H15Z"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M40 98V70H78V98"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M28 50H43V60H28V50Z"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M75 50H90V60H75V50Z"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M48 40H68V50H48V40Z"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </g>
      <defs>
        <clipPath id="clip0_25549_222796">
          <rect width="118" height="118" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const RetirementLiving = ({ value }) => {
  const [innerHeight, setInnerHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setInnerHeight(window.innerHeight);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down(500));
  const onlySmallScreen = useMediaQuery((theme) =>
    theme.breakpoints.down('md')
  );

  return (
    <svg
      width={matchessm ? '40' : '118'}
      height={matchessm ? '40' : '118'}
      viewBox="0 0 118 118"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_25549_222797)">
        <path
          d="M20 98V50L59 20L98 50V98H20Z"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M45 98V70H73V98"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M30 55H43V65H30V55Z"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M75 55H88V65H75V55Z"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M50 40C50 35 55 30 60 30C65 30 70 35 70 40V50"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </g>
      <defs>
        <clipPath id="clip0_25549_222797">
          <rect width="118" height="118" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Land = ({ value }) => {
  const [innerHeight, setInnerHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setInnerHeight(window.innerHeight);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down(500));
  const onlySmallScreen = useMediaQuery((theme) =>
    theme.breakpoints.down('md')
  );

  return (
    <svg
      width={matchessm ? '40' : '118'}
      height={matchessm ? '40' : '118'}
      viewBox="0 0 118 118"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_25549_222798)">
        <rect
          x="15"
          y="50"
          width="88"
          height="40"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M15 90H103"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M40 50V30L59 15L78 30V50"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </g>
      <defs>
        <clipPath id="clip0_25549_222798">
          <rect width="118" height="118" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Acreage = ({ value }) => {
  const [innerHeight, setInnerHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setInnerHeight(window.innerHeight);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down(500));
  const onlySmallScreen = useMediaQuery((theme) =>
    theme.breakpoints.down('md')
  );

  return (
    <svg
      width={matchessm ? '40' : '118'}
      height={matchessm ? '50' : '118'}
      viewBox="0 0 118 118"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_25549_222799)">
        <rect
          x="10"
          y="50"
          width="98"
          height="40"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M10 90H108"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M30 50V25L59 10L88 25V50"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <circle
          cx="40"
          cy="65"
          r="5"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
          fill="none"
        />
        <circle
          cx="78"
          cy="65"
          r="5"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
          fill="none"
        />
      </g>
      <defs>
        <clipPath id="clip0_25549_222799">
          <rect width="118" height="118" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Rural = ({ value }) => {
  const [innerHeight, setInnerHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setInnerHeight(window.innerHeight);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down(500));
  const onlySmallScreen = useMediaQuery((theme) =>
    theme.breakpoints.down('md')
  );

  return (
    <svg
      width={matchessm ? '40' : '118'}
      height={matchessm ? '40' : '118'}
      viewBox="0 0 118 118"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_25549_222800)">
        <path
          d="M20 98V60L59 30L98 60V98H20Z"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M45 98V75H73V98"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M25 60H40V70H25V60Z"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <circle
          cx="85"
          cy="45"
          r="5"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
          fill="none"
        />
        <path
          d="M10 98H108"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </g>
      <defs>
        <clipPath id="clip0_25549_222800">
          <rect width="118" height="118" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const BlockOfApartments = ({ value }) => {
  const [innerHeight, setInnerHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setInnerHeight(window.innerHeight);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down(500));
  const onlySmallScreen = useMediaQuery((theme) =>
    theme.breakpoints.down('md')
  );

  return (
    <svg
      width={matchessm ? '40' : '118'}
      height={matchessm ? '40' : '118'}
      viewBox="0 0 118 118"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_25549_222801)">
        <rect
          x="25"
          y="30"
          width="68"
          height="60"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M45 90V30"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M73 90V30"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M25 50H93"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M25 70H93"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M10 98H108"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </g>
      <defs>
        <clipPath id="clip0_25549_222801">
          <rect width="118" height="118" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const CarParking = ({ value }) => {
  const [innerHeight, setInnerHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setInnerHeight(window.innerHeight);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down(500));
  const onlySmallScreen = useMediaQuery((theme) =>
    theme.breakpoints.down('md')
  );

  return (
    <svg
      width={matchessm ? '40' : '118'}
      height={matchessm ? '40' : '118'}
      viewBox="0 0 118 118"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_25549_222805)">
        <rect
          x="20"
          y="40"
          width="78"
          height="38"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <circle
          cx="40"
          cy="80"
          r="8"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
          fill="none"
        />
        <circle
          cx="80"
          cy="80"
          r="8"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
          fill="none"
        />
        <path
          d="M30 40V30H88V40"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <text
          x="45"
          y="60"
          fontSize="20"
          fill={value ? '#6C2AD2' : '#0D0D0D'}
          fontWeight="bold"
        >
          P
        </text>
      </g>
      <defs>
        <clipPath id="clip0_25549_222805">
          <rect width="118" height="118" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const FollowUpBank = ({ value }) => {
  const [innerHeight, setInnerHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setInnerHeight(window.innerHeight);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down(500));
  const onlySmallScreen = useMediaQuery((theme) =>
    theme.breakpoints.down('md')
  );

  return (
    <svg
      width={matchessm ? '40' : '118'}
      height={matchessm ? '40' : '118'}
      viewBox="0 0 118 118"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_25549_222810)">
        <rect
          x="20"
          y="50"
          width="78"
          height="40"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
          fill="none"
        />
        <polygon
          points="20,50 59,20 98,50"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
          fill="none"
        />
        <line
          x1="30"
          y1="90"
          x2="30"
          y2="50"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
        />
        <line
          x1="88"
          y1="90"
          x2="88"
          y2="50"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
        />
        <circle
          cx="90"
          cy="30"
          r="10"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
          fill="none"
        />
        <path
          d="M87 27 L93 33 M93 27 L87 33"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
        />
      </g>
      <defs>
        <clipPath id="clip0_25549_222810">
          <rect width="118" height="118" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const NoneIcon = ({ value }) => {
  const [innerHeight, setInnerHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setInnerHeight(window.innerHeight);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down(500));
  const onlySmallScreen = useMediaQuery((theme) =>
    theme.breakpoints.down('md')
  );
  const iconSize = matchessm ? 40 : onlySmallScreen ? 78 : 65;
  const color = value ? '#6C2AD2' : '#0D0D0D';
  const strokeWidth = value ? '2.5' : '2';

  return (
    <svg
      width={iconSize}
      height={iconSize}
      viewBox="0 0 118 118"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Circle */}
      <circle
        cx="59"
        cy="59"
        r="45"
        stroke={color}
        strokeWidth={strokeWidth}
        fill="none"
      />

      {/* Diagonal line (forbidden/prohibited symbol) */}
      <line
        x1="25"
        y1="25"
        x2="93"
        y2="93"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
    </svg>
  );
};
export const UploadApprovalNotice = ({ value }) => {
  const [innerHeight, setInnerHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setInnerHeight(window.innerHeight);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down(500));
  const onlySmallScreen = useMediaQuery((theme) =>
    theme.breakpoints.down('md')
  );

  return (
    <svg
      width={matchessm ? '40' : '118'}
      height={matchessm ? '40' : '118'}
      viewBox="0 0 118 118"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_25549_222815)">
        <rect
          x="30"
          y="30"
          width="58"
          height="70"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
          fill="none"
        />
        <path
          d="M59 45V70"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M50 55L59 45L68 55"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle
          cx="80"
          cy="80"
          r="10"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
          fill="none"
        />
        <path
          d="M76 80L79 83L84 77"
          stroke={value ? '#6C2AD2' : '#0D0D0D'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_25549_222815">
          <rect width="118" height="118" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const FamilyChange = ({ value }) => {
  const [innerHeight, setInnerHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setInnerHeight(window.innerHeight);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down(500));
  const onlySmallScreen = useMediaQuery((theme) =>
    theme.breakpoints.down('md')
  );
  const iconSize = matchessm ? '50' : onlySmallScreen ? '60' : '70';
  const color = value ? '#6C2AD2' : '#0D0D0D';

  return (
    <svg
      width={iconSize}
      height={iconSize}
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        {/* Simplified Family Icon */}
        <circle cx="30" cy="50" r="5" fill={color} />
        <circle cx="50" cy="50" r="5" fill={color} />
        <path d="M25 60H35" stroke={color} />
        <path d="M45 60H55" stroke={color} />
        <path d="M40 30C50 30 60 40 60 50" stroke={color} fill="none" />
        <path d="M20 50C20 40 30 30 40 30" stroke={color} fill="none" />
      </g>
    </svg>
  );
};

export const CalendarIcon = ({ value }) => {
  const [innerHeight, setInnerHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setInnerHeight(window.innerHeight);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down(500));
  const onlySmallScreen = useMediaQuery((theme) =>
    theme.breakpoints.down('md')
  );
  const iconSize = matchessm ? '45' : onlySmallScreen ? '55' : '65';
  const color = value ? '#6C2AD2' : '#0D0D0D';

  return (
    <svg
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 2V5"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 2V5"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.5 9.08984H20.5"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 8.5V17C21 20 19.5 22 16 22H8C4.5 22 3 20 3 17V8.5C3 5.5 4.5 3.5 8 3.5H16C19.5 3.5 21 5.5 21 8.5Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.6937 13.6992H15.7027"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.6937 16.6992H15.7027"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9945 13.6992H12.0035"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9945 16.6992H12.0035"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.29529 13.6992H8.30427"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.29529 16.6992H8.30427"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ViewsIcon = ({ value }) => {
  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down(500));
  const onlySmallScreen = useMediaQuery((theme) =>
    theme.breakpoints.down('md')
  );

  return (
    <svg
      width={matchessm ? '40' : onlySmallScreen ? '78' : '118'}
      height={matchessm ? '40' : onlySmallScreen ? '78' : '118'}
      viewBox="0 0 118 118"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 59C10 59 30 30 59 30C88 30 108 59 108 59C108 59 88 88 59 88C30 88 10 59 10 59Z"
        stroke={value ? '#6C2AD2' : '#0D0D0D'}
        strokeWidth="2"
      />
      <circle
        cx="59"
        cy="59"
        r="12"
        stroke={value ? '#6C2AD2' : '#0D0D0D'}
        strokeWidth="2"
      />
    </svg>
  );
};
export const DesignStyleIcon = ({ value }) => {
  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down(500));
  const onlySmallScreen = useMediaQuery((theme) =>
    theme.breakpoints.down('md')
  );

  const color = value ? '#6C2AD2' : '#0D0D0D';

  return (
    <svg
      width={matchessm ? '40' : onlySmallScreen ? '78' : '118'}
      height={matchessm ? '40' : onlySmallScreen ? '78' : '118'}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12 3L3 7.5L12 12L21 7.5L12 3Z"
        stroke={color}
        strokeWidth="0.45"
        strokeLinejoin="round"
      />
      <path
        d="M3 7.5V16.5L12 21V12"
        stroke={color}
        strokeWidth="0.45"
        strokeLinejoin="round"
      />
      <path
        d="M21 7.5V16.5L12 21"
        stroke={color}
        strokeWidth="0.45"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const OutdoorSpaceIcon = ({ value }) => {
  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down(500));
  const onlySmallScreen = useMediaQuery((theme) =>
    theme.breakpoints.down('md')
  );

  const color = value ? '#6C2AD2' : '#0D0D0D';

  return (
    <svg
      width={matchessm ? '40' : onlySmallScreen ? '78' : '118'}
      height={matchessm ? '40' : onlySmallScreen ? '78' : '118'}
      viewBox="0 0 118 118"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* roof */}
      <path
        d="M10 50L59 15L108 50Z"
        stroke={color}
        strokeWidth="2"
        strokeLinejoin="round"
      />

      {/* center pole */}
      <path
        d="M59 50V105"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />

      {/* left chair */}
      <path
        d="M30 80V105"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M30 80L27 72"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M30 88H48"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M48 88V105"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />

      {/* right chair */}
      <path
        d="M88 80V105"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M88 80L91 72"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M70 88H88"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M70 88V105"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const Sqrplus = () => {
  return (
    <svg
      width="70"
      height="71"
      viewBox="0 0 80 81"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        y="0.402344"
        width="80"
        height="80"
        rx="5"
        fill="#BCBBBC"
        fill-opacity="0.1"
      />
      <path
        d="M40 30.4023C40.3315 30.4023 40.6495 30.534 40.8839 30.7685C41.1183 31.0029 41.25 31.3208 41.25 31.6523V39.1523H48.75C49.0815 39.1523 49.3995 39.284 49.6339 39.5185C49.8683 39.7529 50 40.0708 50 40.4023C50 40.7339 49.8683 41.0518 49.6339 41.2862C49.3995 41.5206 49.0815 41.6523 48.75 41.6523H41.25V49.1523C41.25 49.4839 41.1183 49.8018 40.8839 50.0362C40.6495 50.2706 40.3315 50.4023 40 50.4023C39.6685 50.4023 39.3505 50.2706 39.1161 50.0362C38.8817 49.8018 38.75 49.4839 38.75 49.1523V41.6523H31.25C30.9185 41.6523 30.6005 41.5206 30.3661 41.2862C30.1317 41.0518 30 40.7339 30 40.4023C30 40.0708 30.1317 39.7529 30.3661 39.5185C30.6005 39.284 30.9185 39.1523 31.25 39.1523H38.75V31.6523C38.75 31.3208 38.8817 31.0029 39.1161 30.7685C39.3505 30.534 39.6685 30.4023 40 30.4023V30.4023Z"
        fill="#666666"
      />
    </svg>
  );
};
export const Sqrplusadd = () => {
  return (
    <svg
      width="75"
      height="41"
      viewBox="0 0 75 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        y="0.902832"
        width="74"
        height="39"
        rx="4.5"
        fill="#6C2AD2"
        fill-opacity="0.1"
      />
      <path
        d="M16 14.4028C16.1989 14.4028 16.3897 14.4818 16.5303 14.6225C16.671 14.7632 16.75 14.9539 16.75 15.1528V19.6528H21.25C21.4489 19.6528 21.6397 19.7318 21.7803 19.8725C21.921 20.0132 22 20.2039 22 20.4028C22 20.6017 21.921 20.7925 21.7803 20.9332C21.6397 21.0738 21.4489 21.1528 21.25 21.1528H16.75V25.6528C16.75 25.8517 16.671 26.0425 16.5303 26.1832C16.3897 26.3238 16.1989 26.4028 16 26.4028C15.8011 26.4028 15.6103 26.3238 15.4697 26.1832C15.329 26.0425 15.25 25.8517 15.25 25.6528V21.1528H10.75C10.5511 21.1528 10.3603 21.0738 10.2197 20.9332C10.079 20.7925 10 20.6017 10 20.4028C10 20.2039 10.079 20.0132 10.2197 19.8725C10.3603 19.7318 10.5511 19.6528 10.75 19.6528H15.25V15.1528C15.25 14.9539 15.329 14.7632 15.4697 14.6225C15.6103 14.4818 15.8011 14.4028 16 14.4028Z"
        fill="#6C2AD2"
      />
      <path
        d="M39.824 23.9228H34.96L34.064 26.4028H32.528L36.56 15.3148H38.24L42.256 26.4028H40.72L39.824 23.9228ZM39.408 22.7388L37.392 17.1068L35.376 22.7388H39.408ZM43.4693 21.9868C43.4693 21.0908 43.6506 20.3068 44.0133 19.6348C44.3759 18.9522 44.8719 18.4242 45.5013 18.0508C46.1413 17.6775 46.8559 17.4908 47.6453 17.4908C48.3279 17.4908 48.9626 17.6508 49.5493 17.9708C50.1359 18.2802 50.5839 18.6908 50.8933 19.2028V14.5628H52.3653V26.4028H50.8933V24.7548C50.6053 25.2775 50.1786 25.7095 49.6133 26.0508C49.0479 26.3815 48.3866 26.5468 47.6293 26.5468C46.8506 26.5468 46.1413 26.3548 45.5013 25.9708C44.8719 25.5868 44.3759 25.0482 44.0133 24.3548C43.6506 23.6615 43.4693 22.8722 43.4693 21.9868ZM50.8933 22.0028C50.8933 21.3415 50.7599 20.7655 50.4933 20.2748C50.2266 19.7842 49.8639 19.4108 49.4053 19.1548C48.9573 18.8882 48.4613 18.7548 47.9173 18.7548C47.3733 18.7548 46.8773 18.8828 46.4293 19.1388C45.9813 19.3948 45.6239 19.7682 45.3573 20.2588C45.0906 20.7495 44.9573 21.3255 44.9573 21.9868C44.9573 22.6588 45.0906 23.2455 45.3573 23.7468C45.6239 24.2375 45.9813 24.6162 46.4293 24.8828C46.8773 25.1388 47.3733 25.2668 47.9173 25.2668C48.4613 25.2668 48.9573 25.1388 49.4053 24.8828C49.8639 24.6162 50.2266 24.2375 50.4933 23.7468C50.7599 23.2455 50.8933 22.6642 50.8933 22.0028ZM54.2818 21.9868C54.2818 21.0908 54.4631 20.3068 54.8258 19.6348C55.1884 18.9522 55.6844 18.4242 56.3138 18.0508C56.9538 17.6775 57.6684 17.4908 58.4578 17.4908C59.1404 17.4908 59.7751 17.6508 60.3618 17.9708C60.9484 18.2802 61.3964 18.6908 61.7058 19.2028V14.5628H63.1778V26.4028H61.7058V24.7548C61.4178 25.2775 60.9911 25.7095 60.4258 26.0508C59.8604 26.3815 59.1991 26.5468 58.4418 26.5468C57.6631 26.5468 56.9538 26.3548 56.3138 25.9708C55.6844 25.5868 55.1884 25.0482 54.8258 24.3548C54.4631 23.6615 54.2818 22.8722 54.2818 21.9868ZM61.7058 22.0028C61.7058 21.3415 61.5724 20.7655 61.3058 20.2748C61.0391 19.7842 60.6764 19.4108 60.2178 19.1548C59.7698 18.8882 59.2738 18.7548 58.7298 18.7548C58.1858 18.7548 57.6898 18.8828 57.2418 19.1388C56.7938 19.3948 56.4364 19.7682 56.1698 20.2588C55.9031 20.7495 55.7698 21.3255 55.7698 21.9868C55.7698 22.6588 55.9031 23.2455 56.1698 23.7468C56.4364 24.2375 56.7938 24.6162 57.2418 24.8828C57.6898 25.1388 58.1858 25.2668 58.7298 25.2668C59.2738 25.2668 59.7698 25.1388 60.2178 24.8828C60.6764 24.6162 61.0391 24.2375 61.3058 23.7468C61.5724 23.2455 61.7058 22.6642 61.7058 22.0028Z"
        fill="#6C2AD2"
      />
      <rect
        x="0.5"
        y="0.902832"
        width="74"
        height="39"
        rx="4.5"
        stroke="#F0F0F0"
      />
    </svg>
  );
};
